import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'

import { listDepartmentByRegion, listSpecialties, listEquipments } from '../../datas/DatasActions'
import { updateProvider } from '../ProviderActions'
import FormStepThree from '../components/FormStepThree'

import { parseValueProvider } from '../../utils/parse'

import { addNotifSuccess, addNotifError } from '../../notification/NotificationActions'


const mapStateToProps = (state) => {
    var initialValues = state.provider.provider.provider;
    if (initialValues.intervention_time_start === null){
        initialValues.intervention_time_start = 7
    }
    if (initialValues.intervention_time_end === null){
        initialValues.intervention_time_end = 22
    }
    return {
        departments : state.datas.departments,
        specialties : state.datas.specialties,
        equipments : state.datas.equipments,
        user : state.user,
        provider : state.provider.provider,
        initialValues
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        listDepartmentByRegion: (id) => {
            return dispatch(listDepartmentByRegion(id))
        },
        listSpecialties:() => {
            return dispatch(listSpecialties())
        },
        listEquipments:() => {
            return dispatch(listEquipments())
        }
    }
};

const validate = values => {
  const errors = {};

  if (values.intervention_time_start < 0 || values.intervention_time_start > 23) {
    errors.intervention_time_start = 'Invalide (0-23)'
  }

  if (values.intervention_time_end < 0 || values.intervention_time_end > 23) {
    errors.intervention_time_end = 'Invalide (0-23)'
  }

  if (parseInt(values.intervention_time_start) > parseInt(values.intervention_time_end) ) {
    errors.intervention_time_end = "L'heure de fin doit etre supérieur à l'heure de début"
  }
  
  if (values.departments.length === 0){
    errors.departments = "Obligatoire"
  }

  return errors
};

const config = {
    form: 'FormStepThreeForm',
    onSubmit: (values, dispatch, props) => {
        window.scrollTo(0, 0);

        const fields = [
            "administratives_number", "technicians_number", "intervention_planning", "intervention_time_start", "intervention_time_end",
            "departments", "price_file", "price_1", "price_2", "price_3", "equipments", "specialties", "skills", "range_action"
        ];
        var datas = parseValueProvider(fields, values);
        
        return dispatch(updateProvider(props.provider.provider.id, datas))
            .then((response) => {
                if(props.create){
                    props.nextPage()
                }else{
                    dispatch(addNotifSuccess("Vos informations sont enregistrées", "Confirmation"))
                }
                
            })
            .catch((error) => {
                dispatch(addNotifError("Veuillez recommencer.", "Erreur"))
            })   
    },
    validate
};

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(config)(FormStepThree))



// WEBPACK FOOTER //
// ./src/provider/containers/FormStepThreeContainer.js